export default "__VITE_ASSET__hZhLJd8C__"